import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

// import HtmlImg from '../../static/assets/homepage/icon-html-5.svg';
// import CssImg from '../../static/assets/homepage/icon-css-3.svg';
// import JsImg from '../../static/assets/homepage/icon-js.svg';
// import ReactImg from '../../static/assets/homepage/icon-react.svg';
// import GitImg from '../../static/assets/homepage/icon-git.svg';
// import GitHubImg from '../../static/assets/homepage/icon-github.svg';
// import TsImg from '../../static/assets/homepage/icon-ts.svg';
// import SassImg from '../../static/assets/homepage/icon-sass.svg';

import HtmlImg from '../../static/assets/landing/react.svg';
import CssImg from '../../static/assets/landing/angular.svg';
import JsImg from '../../static/assets/landing/vue.svg';
import ReactImg from '../../static/assets/landing/REST.svg';
import GitImg from '../../static/assets/homepage/icon-git.svg';
import GitHubImg from '../../static/assets/landing/GQL.svg';
import TsImg from '../../static/assets/landing/figma.svg';
import SassImg from '../../static/assets/landing/WS.svg';

import './Hero.scss';
import paths from '../../lib/consts/paths';

const Hero = () => {
	const navigate = useNavigate();
	return (
		<div className="hero">
			<div className="context">
				{/* <div>
					<img src={Guru} alt="Codeway.TODAY" style={{ width: '15vw' }} />
				</div> */}
				<h1 className="company">
					Codeway.<span>TODAY</span>
				</h1>
				<h1 className="slogan">
					The best service to build training apps. <br /> Real Backend APIs, product
					design with UI/UX, on-demand consultations.
				</h1>
				<div style={{ display: 'flex', justifyContent: 'flex-start' }}>
					{/* <button type="button">Start learning code</button> */}
					<Button onClick={() => navigate(paths.courses)}>
						Start training with real API
					</Button>
				</div>
			</div>

			<div className="grid-wrapper">
				<div className="grid-container">
					<div className="grid-item">
						<img
							className="home-banner__list-img"
							src={HtmlImg}
							alt="Codeway.TODAY"
						/>
					</div>
					<div className="grid-item">
						<img className="home-banner__list-img" src={CssImg} alt="Codeway.TODAY" />
					</div>
					<div className="grid-item">
						<img className="home-banner__list-img" src={JsImg} alt="Codeway.TODAY" />
					</div>
					<div className="grid-item">
						<img
							className="home-banner__list-img"
							src={GitHubImg}
							alt="Codeway.TODAY"
						/>
					</div>
					{/* <div className="grid-item">
						<img
							className="home-banner__list-img"
							src={GitHubImg}
							alt="Codeway.TODAY"
						/>
					</div> */}
					<div className="grid-item">
						<img className="home-banner__list-img" src={TsImg} alt="Codeway.TODAY" />
					</div>
					<div className="grid-item">
						<img
							className="home-banner__list-img"
							src={ReactImg}
							alt="Codeway.TODAY"
						/>
					</div>

					<div className="grid-item">
						<img
							className="home-banner__list-img"
							src={SassImg}
							alt="Codeway.TODAY"
						/>
					</div>
				</div>
			</div>

			<div className="area">
				<ul className="circles">
					<li>
						<img
							className="home-banner__list-img"
							src={HtmlImg}
							alt="Codeway.TODAY"
						/>
					</li>
					<li>
						<img className="home-banner__list-img" src={CssImg} alt="Codeway.TODAY" />
					</li>
					<li>
						<img className="home-banner__list-img" src={JsImg} alt="Codeway.TODAY" />
					</li>
					<li>
						<img
							className="home-banner__list-img"
							src={ReactImg}
							alt="Codeway.TODAY"
						/>
					</li>
					<li>
						<img className="home-banner__list-img" src={GitImg} alt="Codeway.TODAY" />
					</li>
					<li>
						<img
							className="home-banner__list-img"
							src={GitHubImg}
							alt="Codeway.TODAY"
						/>
					</li>
					<li>
						<img className="home-banner__list-img" src={TsImg} alt="Codeway.TODAY" />
					</li>
					<li>
						<img
							className="home-banner__list-img"
							src={SassImg}
							alt="Codeway.TODAY"
						/>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default Hero;
